import { combineReducers } from 'redux'
import orders from './orders';
import drivers from './drivers';
import scheduled from './scheduled';
import session from './session';
import store from './store';

export default combineReducers({
    orders,
    drivers,
    scheduled,
    session,
    store
})